import { render, staticRenderFns } from "./ZoomableImage.vue?vue&type=template&id=c7358320&scoped=true&name=zoomable-image&"
import script from "./ZoomableImage.vue?vue&type=script&lang=js&"
export * from "./ZoomableImage.vue?vue&type=script&lang=js&"
import style0 from "./ZoomableImage.vue?vue&type=style&index=0&id=c7358320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7358320",
  null
  
)

export default component.exports